import * as React from "react";
const DistributeCenterSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 15v1H2v-1h13Zm-5-8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3Zm0 1H7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm5-5v1H2V3h13Z" }));
DistributeCenterSmall.displayName = "DistributeCenterSmall";
var DistributeCenterSmall_default = DistributeCenterSmall;
export {
  DistributeCenterSmall_default as default
};
